/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { CreateSessionExerciseDto } from './create-session-exercise-dto';
import { EnShared } from './en-shared';
import { JoinEntityDto } from './join-entity-dto';
 /**
 *
 *
 * @export
 * @interface CreateSessionDto
 */
export interface CreateSessionDto {

    /**
     * @type {string}
     * @memberof CreateSessionDto
     */
    title: string;

    /**
     * @type {number}
     * @memberof CreateSessionDto
     */
    laps: number;

    /**
     * Rest between laps. If 0 Unity must use `SessionExercise.rest` (rest between sets)
     *
     * @type {number}
     * @memberof CreateSessionDto
     */
    rest: number;

    /**
     * @type {JoinEntityDto}
     * @memberof CreateSessionDto
     */
    mobility: JoinEntityDto;

    /**
     * @type {boolean}
     * @memberof CreateSessionDto
     */
    isTemplate?: boolean;

    /**
     * @type {EnShared}
     * @memberof CreateSessionDto
     */
    shared?: EnShared;

    /**
     * @type {string}
     * @memberof CreateSessionDto
     */
    note?: string | null;

    /**
     * @type {Array<CreateSessionExerciseDto | JoinEntityDto>}
     * @memberof CreateSessionDto
     */
    exercises: Array<CreateSessionExerciseDto | JoinEntityDto>;
}
